export default __webpack_public_path__ + "static/media/GedulingiPietus.b01da689.svg";